<template>
  <CForm>
    <CInput label="Course code" placeholder="Please enter the course code" type="number" v-model="form.courseCode"/>
    <CInput label="Course name" placeholder="Please enter the course name" v-model="form.name"/>
    Year
    <CRow class="mb-3 mt-2">
      <CCol>
        <input id="1" name="year" type="radio" v-model="form.year" value="1"><label class="ml-2 mr-4" for="1">1</label>
        <input id="2" name="year" type="radio" v-model="form.year" value="2"><label class="ml-2 mr-4" for="2">2</label>
        <input id="3" name="year" type="radio" v-model="form.year" value="3"><label class="ml-2 mr-4" for="3">3</label>
        <input id="4" name="year" type="radio" v-model="form.year" value="4"><label class="ml-2 mr-4" for="4">4</label>
        <input id="5" name="year" type="radio" v-model="form.year" value="5"><label class="ml-2 mr-4" for="5">5</label>
        <input id="6" name="year" type="radio" v-model="form.year" value="6"><label class="ml-2 mr-4" for="6">6</label>
      </CCol>
    </CRow>
    <CButton @click="cancel" class="mr-2" color="danger" size="sm">Cancel</CButton>
    <CButton :disabled="completedForm" @click="confirm" color="success" size="sm">Confirm</CButton>
  </CForm>
</template>

<script>
export default {
  name: "addCourse",
  props: {
    form: Object
  },
  computed: {
    completedForm() {
      if (this.form.courseCode.length === 7 && this.form.name !== "" && this.form.year !== 0) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    "form.courseCode"(value) {
      if (value.length > 7) {
        this.form.courseCode = ""
      }
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel")
    },
    confirm() {
      this.$emit("confirm", this.form)
    }
  }
}
</script>
